module.exports = __webpack_public_path__ + "public-ui/img/msp.fc2fa7bc.svg";